import React, { useContext, useEffect, useState } from "react";
import { AnalyticsCounts } from "../../types/AnalyticsCounts";
import { getAnalyticsCounts } from "../../components/apis/music-api";
import callApi from "../../components/call-api/call-api";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";

const Analytics = () => {    
    const [ counts, setCounts ] = useState<AnalyticsCounts>();
    const { getAccessToken } = useContext(AuthenticationContext);

    useEffect(() => {
        callApi<AnalyticsCounts>(getAnalyticsCounts(getAccessToken()), setCounts);
    }, [getAccessToken]);

    const format = (num: number) => num.toLocaleString("en-US");
    
    return (
        <>
            <Stack spacing={2}>
                <Box>
                    <Typography variant='h5'>Analytics</Typography>
                </Box>
            </Stack>
            <h4>Counts</h4>
            <Stack direction="column" sx={{ width: '240px' }}>
                {counts &&
                    <>
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Artists </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.artists)}</Typography></Box>
                        </Stack>
                    </Box>
                    <Divider />
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Albums </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.albums)}</Typography></Box>
                        </Stack>
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Album Tracks </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.tracks)}</Typography></Box>
                        </Stack>
                    </Box>
                    <Divider />
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Compilations </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.compilations)}</Typography></Box>
                        </Stack>
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Compilation Tracks </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.compilationTracks)}</Typography></Box>
                        </Stack>
                    </Box> 
                    <Divider />
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Total Recordings </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.albums + counts.compilations)}</Typography></Box>
                        </Stack>
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={3}>
                            <Box sx={{ minWidth: '150px' }}><Typography variant="body1" display="inline">Total Tracks </Typography></Box>
                            <Box sx={{ minWidth: '60px', textAlign: 'right' }}><Typography variant="body1" display="inline" color="blue">{format(counts.tracks + counts.compilationTracks)}</Typography></Box>
                        </Stack>
                    </Box>
                    </>
                }
            </Stack>
        </>
    );
}

export default Analytics;
